module.exports = __webpack_public_path__ + "static/img/app.fc30b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.png
// module id = /5Ul
// module chunks = 101